import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { Input, Radio, VisualPicker } from '@salesforce/design-system-react';
import { TestSettings } from '../images/illustrations/experiment-tips';
import { ExperimentEditStep } from '../';

import './ExperimentEditSetting.scss';

class ExperimentEditSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      engine_name: this.props.experiment.engine_name,
      end_trigger: this.props.experiment.end_trigger,
      end_value: this.props.experiment.end_value || 0
    };
  }
  getI18nID(suffix) {
    return `components.experiment.experimentWizard.${suffix}`;
  }

  renderTips() {
    const { formatMessage } = this.props.intl;
    const tipTitle = formatMessage({
      id: this.getI18nID('step2.title')
    });
    const tip1 = formatMessage({
      id: this.getI18nID('step2.tip1')
    });
    const tip2 = formatMessage({
      id: this.getI18nID('step2.tip2')
    });
    return (
      <div className="tips slds-col">
        <div className="tip-image">
          <TestSettings />
        </div>
        <p>{tipTitle}</p>
        <ul>
          <li>{tip1}</li>
          <li>{tip2}</li>
        </ul>
      </div>
    );
  }

  handleEngineChange(value) {
    this.setState({ engine_name: value });
    this.props.onFieldChange('engine_name', value);
  }

  renderEngine() {
    const { formatMessage } = this.props.intl;
    const { experiment } = this.props;
    return (
      <div className="setting-test-mode">
        <VisualPicker
          label={formatMessage({ id: this.getI18nID('engine.title') })}
          id="visual-picker-non-coverable-radio"
        >
          <Radio
            id="visual-picker-non-coverable-radio-1"
            value="ECS"
            checked={this.state.engine_name === 'ECS'}
            disabled={
              experiment.status !== 'DRAFT' && this.state.engine_name !== 'ECS'
            }
            onChange={event => this.handleEngineChange(event.target.value)}
            onRenderVisualPicker={() => (
              <span>
                <span className="slds-text-heading_medium slds-m-bottom_x-small">
                  {formatMessage({ id: this.getI18nID('engine.ecs.label') })}
                </span>
                <span className="slds-text-title">
                  {formatMessage({
                    id: this.getI18nID('engine.ecs.description')
                  })}
                </span>
              </span>
            )}
          />
          <Radio
            id="visual-picker-non-coverable-radio-2"
            value="ABN"
            checked={this.state.engine_name === 'ABN'}
            disabled={
              experiment.status !== 'DRAFT' && this.state.engine_name !== 'ABN'
            }
            onChange={event => this.handleEngineChange(event.target.value)}
            onRenderVisualPicker={() => (
              <span>
                <span className="slds-text-heading_medium slds-m-bottom_x-small">
                  {formatMessage({
                    id: this.getI18nID('engine.abn.label')
                  })}
                </span>
                <span className="slds-text-title">
                  {formatMessage({
                    id: this.getI18nID('engine.abn.description')
                  })}
                </span>
              </span>
            )}
          />
        </VisualPicker>
      </div>
    );
  }

  renderECSWinner() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="winner-section">
        <p className="winner-title">
          {formatMessage({ id: this.getI18nID('fields.winner.title') })}
        </p>
        <p className="winner-ecs">
          {formatMessage({ id: this.getI18nID('fields.winner.ecs') })}
        </p>
      </div>
    );
  }

  handleWinnerChange(value) {
    this.setState({ end_trigger: value });
    this.props.onFieldChange('end_trigger', value);
  }

  renderCounter() {
    const { formatMessage } = this.props.intl;
    const label =
      this.state.end_trigger === 'SELECTIONS'
        ? formatMessage({
            id: this.getI18nID('fields.winner.abn.endSelections')
          })
        : formatMessage({ id: this.getI18nID('fields.winner.abn.endClicks') });
    return (
      <div className="counter-winner">
        <Input
          id="selection-input"
          label={label}
          minValue={0}
          onChange={(event, data) => {
            this.setState({ end_value: data.value });
            this.props.onFieldChange('end_value', data.value);
          }}
          step={100}
          value={this.state.end_value}
          variant="counter"
        />
      </div>
    );
  }

  renderABNWinner() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="winner-section">
        <p className="winner-title">
          {formatMessage({ id: this.getI18nID('fields.winner.title') })}
        </p>
        <div className="abn-winner-options winner">
          <Radio
            key="manual"
            id="manual"
            labels={{
              label: formatMessage({
                id: this.getI18nID('fields.winner.abn.manual')
              })
            }}
            value="MANUAL"
            variant="base"
            onChange={event => this.handleWinnerChange(event.target.value)}
            checked={this.state.end_trigger === 'MANUAL'}
          />
          <Radio
            key="clicks"
            id="clicks"
            labels={{
              label: formatMessage({
                id: this.getI18nID('fields.winner.abn.clicks')
              })
            }}
            value="CLICKS"
            variant="base"
            onChange={event => this.handleWinnerChange(event.target.value)}
            checked={this.state.end_trigger === 'CLICKS'}
          />
          {this.state.end_trigger === 'CLICKS' ? this.renderCounter() : null}
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="experiment-container slds-grid">
        <ExperimentEditStep
          actions={this.props.actions}
          canNav={true}
          step="step2"
        />
        <div className="settings slds-col">
          <p className="settings-container-title">
            {formatMessage({ id: this.getI18nID('engine.header') })}
          </p>
          {this.renderEngine()}
          {this.state.engine_name === 'ECS'
            ? this.renderECSWinner()
            : this.renderABNWinner()}
        </div>
        {this.renderTips()}
      </div>
    );
  }
}

ExperimentEditSetting.propTypes = {
  actions: PropTypes.object,
  experiments: PropTypes.object,
  modals: PropTypes.object,
  experiment: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'create']),
  onFieldChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentEditSetting);
